import { createContext, useContext } from "react";
import type { ZodObject, ZodRawShape } from "zod";

interface DetailFieldSectionContextValue {
  schema: ZodObject<ZodRawShape>;
  data: Record<string, unknown>;
  module: string;
}

export const DetailFieldSectionContext =
  createContext<DetailFieldSectionContextValue | null>(null);

export const useDetailFieldSectionContext = () => {
  const context = useContext(DetailFieldSectionContext);
  if (!context) {
    throw new Error("useDetailFieldSectionContext must be used within Section");
  }
  return context;
};
